'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotAreaStackedIcon = function PlotAreaStackedIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M0 25.25v6.125h32v-10.25h-1.813L20.124 25l-7.313-6.688zm0-8.312v4.5l12.813-6.813 7.25 6.813 9.938-3.813h2v-16l-9.813 10.688-8.313-8.875z' })
    );
};

exports.default = PlotAreaStackedIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotAreaStackedIcon.js
// module id = 645
// module chunks = 0